// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cpl-page {
  color: var(--cui-text);
}

.cpl-body {
  position: relative; /* absolutely placed bits (hidden file inputs, editor popups) stay inside this scroll area —
                         without it they were placed against the whole document and made the browser page scroll */
  width: 100%;
  box-sizing: border-box;
}

.cpl-padded {
  padding: 16px 20px 24px;
}

.cpl-bg-subtle {
  background: var(--cui-bg-subtle);
}

.cpl-bg-plain {
  background: var(--cui-bg);
}

.cpl-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.cpl-subtitle {
  flex: 1 1 260px;
  min-width: 0;
  margin: 0;
  color: var(--cui-text-muted);
  font-size: var(--cui-font-size);
  line-height: 1.5;
}

.cpl-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-left: auto;
}

/* fill: the body is a flex column of fixed height (.formDiv); everything keeps its size except the table,
   which shrinks to the space left (only as tall as its rows, never under 320px — below that the page scrolls) */
.cpl-fill {
  display: flex;
  flex-direction: column;
}

/* .cpl-fillStack: the page's wrapper div when cards / sections sit above the table */
.cpl-fill > *,
.cpl-fill > .cpl-fillStack > * {
  flex-shrink: 0;
}

.cpl-fill > .cpl-fillStack {
  flex: 0 1 auto;
  min-height: 0;
}

.cpl-fill > .cat-wrap,
.cpl-fill > .cpl-fillStack > .cat-wrap {
  flex: 0 1 auto;
  min-height: 320px;
  max-height: none;
}

/* Tablet */
@media (max-width: 992px) {
  .cpl-padded {
    padding: 14px 16px 20px;
  }
}

/* Phone: actions go full width under the subtitle */
@media (max-width: 576px) {
  .cpl-padded {
    padding: 12px 12px 18px;
  }

  .cpl-actions {
    width: 100%;
    margin-left: 0;
  }

  .cpl-actions > * {
    flex: 1 1 auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/CustomPageLayout/CustomPageLayout.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB,EAAE;kHAC4F;EAChH,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,4BAA4B;EAC5B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;gHACgH;AAChH;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,qFAAqF;AACrF;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA,oDAAoD;AACpD;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".cpl-page {\n  color: var(--cui-text);\n}\n\n.cpl-body {\n  position: relative; /* absolutely placed bits (hidden file inputs, editor popups) stay inside this scroll area —\n                         without it they were placed against the whole document and made the browser page scroll */\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.cpl-padded {\n  padding: 16px 20px 24px;\n}\n\n.cpl-bg-subtle {\n  background: var(--cui-bg-subtle);\n}\n\n.cpl-bg-plain {\n  background: var(--cui-bg);\n}\n\n.cpl-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.cpl-subtitle {\n  flex: 1 1 260px;\n  min-width: 0;\n  margin: 0;\n  color: var(--cui-text-muted);\n  font-size: var(--cui-font-size);\n  line-height: 1.5;\n}\n\n.cpl-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-left: auto;\n}\n\n/* fill: the body is a flex column of fixed height (.formDiv); everything keeps its size except the table,\n   which shrinks to the space left (only as tall as its rows, never under 320px — below that the page scrolls) */\n.cpl-fill {\n  display: flex;\n  flex-direction: column;\n}\n\n/* .cpl-fillStack: the page's wrapper div when cards / sections sit above the table */\n.cpl-fill > *,\n.cpl-fill > .cpl-fillStack > * {\n  flex-shrink: 0;\n}\n\n.cpl-fill > .cpl-fillStack {\n  flex: 0 1 auto;\n  min-height: 0;\n}\n\n.cpl-fill > .cat-wrap,\n.cpl-fill > .cpl-fillStack > .cat-wrap {\n  flex: 0 1 auto;\n  min-height: 320px;\n  max-height: none;\n}\n\n/* Tablet */\n@media (max-width: 992px) {\n  .cpl-padded {\n    padding: 14px 16px 20px;\n  }\n}\n\n/* Phone: actions go full width under the subtitle */\n@media (max-width: 576px) {\n  .cpl-padded {\n    padding: 12px 12px 18px;\n  }\n\n  .cpl-actions {\n    width: 100%;\n    margin-left: 0;\n  }\n\n  .cpl-actions > * {\n    flex: 1 1 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
